import { combineReducers } from 'redux'
import {reduceRespondent} from './ReducerRespondent' 
import {reduceClient} from './ReducerClient' 
import {LOADING_CHANGE , COLLAPSED_CHANGE , ERROR_APP, INFO_RESPONDENT_PUBLIC , SHOW_MODAL_SUBSCRIPTION, COLLAPSED_HEADER_CHANGE, LANGUAGE, TOKEN } from '../actions/ActionApp'

const INITIAL_STATE = {
    loading: false,
    collapseHeader: false,
    collapsed: false,
    error: {},
    infoRespondent: {},
    showPay: false,
    language: navigator.language.includes('en') ?  'en' : 'es',
    token: ''
}

/**
 * "If the action type is LOADING_CHANGE, then change the loading property to the opposite of what it
 * is currently."
 * 
 * If you're not familiar with the syntax, it's just a switch statement. 
 * 
 * The default case is just a return of the state. 
 * 
 * The other cases are where the magic happens. 
 * 
 * The first thing we do is change the state. 
 * 
 * Then we return a new object with the spread operator. 
 * 
 * The spread operator is just a way to copy the state object. 
 * 
 * The reason we do this is because we don't want to mutate the state. 
 * 
 * We want to return a new object with the changes we made. 
 * 
 * This is the basic idea of redux. 
 * 
 * You never want to mutate the state.
 * @param [state] - The current state of the store.
 * @param [action] - The action object that was dispatched.
 * @returns The state is being returned.
 */
const reduceApp = (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case LOADING_CHANGE:
            state.loading = !state.loading;
            return {
                ...state
            }
        case COLLAPSED_CHANGE:
            state.collapsed = !state.collapsed;
            return {
                ...state
            }
        case COLLAPSED_HEADER_CHANGE:
            state.collapseHeader = !state.collapseHeader;
            return {
                ...state
            }
        case ERROR_APP:
            return {
                ...state.error
            }
        case INFO_RESPONDENT_PUBLIC:
            return {
                ...state
            }
        case SHOW_MODAL_SUBSCRIPTION:
            state.showPay = !state.showPay;
            return {
                ...state
            }
        case LANGUAGE:
            state.language = action.data
            return {
                ...state
            }
        case TOKEN:
            state.token = action.data
            return {
                ...state
            }
        default:
            return state;
    }
};

const rootReducer = combineReducers({
  reduceRespondent,
  reduceClient,
  reduceApp
})

export default rootReducer
